export default function About() {
  return (
    <section id="about" className="py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-16 items-start">
          <div className="relative">
            <div className="rounded-3xl overflow-hidden shadow-2xl w-full h-[640px]">
              <img
                src="https://storage.readdy-site.link/project_files/93017206-e53a-40a0-b3f7-6964e97b7467/34f7c704-756c-4092-a7a3-b0bbece7e4f2_Gemini_Generated_Image_6075yg6075yg6075.png?v=6c2e4a9ad40549d23e80c9ebb56c4880"
                alt="Jagroop Kaur - Physiotherapist at Aura Align Physio Clontarf QLD"
                title="Jagroop Kaur Physiotherapist Clontarf"
                className="w-full h-full object-cover object-top"
              />
            </div>
            <div className="absolute -bottom-6 -right-6 bg-white rounded-2xl shadow-xl p-5 max-w-[220px]">
              <div className="flex items-center space-x-3 mb-2">
                <div className="w-10 h-10 flex items-center justify-center rounded-full bg-teal-50">
                  <i className="ri-award-line text-teal-700 text-xl"></i>
                </div>
                <div>
                  <div className="font-bold text-gray-900 text-sm">AHPRA Registered</div>
                  <div className="text-gray-500 text-xs">Physiotherapist</div>
                </div>
              </div>
            </div>
          </div>

          <div className="space-y-6">
            <div className="inline-flex items-center space-x-2 mb-2">
              <i className="ri-leaf-line text-teal-700 text-xl"></i>
              <span className="text-teal-700 font-semibold tracking-wider uppercase text-sm">Meet Your Physio</span>
            </div>
            <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 leading-tight" style={{ fontFamily: 'Georgia, serif' }}>
              Hi, I&apos;m <span className="text-teal-700">Jagroop Kaur</span>
            </h2>
            <div className="space-y-4 text-gray-600 leading-relaxed text-[15px]">
              <p>I&apos;m a dedicated <strong>physiotherapist</strong> with four years of clinical experience specialising in <strong>aged care and community physiotherapy</strong>. I am passionate about helping older adults and community clients regain their independence, improve functional mobility, and enjoy a better quality of life through evidence-based rehabilitation.</p>
              <p>After completing my <strong>Bachelor of Physiotherapy</strong>, I pursued a <strong>Master of Health Services Management</strong> to deepen my understanding of holistic, patient-centred care systems. This combination allows me to deliver high-quality, coordinated rehabilitation that addresses both immediate needs and long-term wellbeing.</p>
              <p>My approach centres on an <strong>active recovery model</strong> — combining hands-on manual therapy with personalised exercise programs to treat the root causes of pain and dysfunction, rather than just managing symptoms. Over the years, I have successfully supported hundreds of patients through complex rehabilitation journeys, from post-operative recovery and mobility challenges to maintaining independence in daily activities.</p>
              <p>I pride myself on creating a warm, supportive, and empowering environment where every patient feels truly heard, respected, and motivated to take an active role in their progress.</p>
              <p className="text-gray-500 italic">Outside the clinic, I&apos;m a gym enthusiast who loves staying active and exploring new adventures. I&apos;m also passionate about cooking healthy, nourishing meals — I truly believe that a balanced lifestyle, including movement, good nutrition, rest, and joy, forms the foundation of lasting physical health and wellbeing.</p>
            </div>
            <div className="grid grid-cols-3 gap-4 pt-6">
              <div className="text-center p-5 bg-white rounded-2xl shadow-sm">
                <div className="text-3xl font-bold text-teal-700 mb-1">4+</div>
                <div className="text-xs text-gray-600 font-medium">Years Clinical Experience</div>
              </div>
              <div className="text-center p-5 bg-white rounded-2xl shadow-sm">
                <div className="text-3xl font-bold text-teal-700 mb-1">500+</div>
                <div className="text-xs text-gray-600 font-medium">Patients Treated</div>
              </div>
              <div className="text-center p-5 bg-white rounded-2xl shadow-sm">
                <div className="text-3xl font-bold text-teal-700 mb-1">2</div>
                <div className="text-xs text-gray-600 font-medium">Degrees Earned</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
